import { Component, ElementRef, Input, OnInit, AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/autocomplete';
import { fromEvent, Observable, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';


@Component({
    selector: 'app-search-controle',
    templateUrl: './search-controle.component.html',
    styleUrls: ['./search-controle.component.scss'],
    providers: [MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER]
})
export class AppSearchControleComponent implements OnInit, AfterViewInit {
    @Input() placeholder: any = "";
    @Input() class: any = "";
    @Input() isAutoComplete: boolean = false;
    @Input() autoRef: any;
    @Input() currentValue: any = '';
    @ViewChild('searchElement') searchElement: ElementRef;
    @Output() search: EventEmitter<string> = new EventEmitter();
    @Output() blur: EventEmitter<string> = new EventEmitter();
    @Input() formContrl: any
    constructor() {
    }

    ngOnInit() {
    }
    ngAfterViewInit() {
        this.getInputValue()
            .subscribe({
                next: (text: string) => {
                    if (typeof (text) === 'string') {
                        this.search.emit(text.trim());
                    }
                }
            });
            if(!this.formContrl){
                timer(700).subscribe(() => {
                    this.searchElement.nativeElement.value = this.currentValue;
                })
            }
    }
    onBlur() {
        timer(600).subscribe(() => {
            this.blur.emit();
        })
    }

    getInputValue(): Observable<any> {
        if (this.formContrl) {
            return this.formContrl.valueChanges
                .pipe(debounceTime(500),
                    distinctUntilChanged()
                )
        } else {
            return fromEvent(this.searchElement.nativeElement, 'keyup')
                .pipe(debounceTime(500),
                    distinctUntilChanged(),
                    map((event: any) => {
                        return event.target.value;
                    })
                )
        }
    }
}
